export default __webpack_public_path__ + "static/media/footprint-info-01.a47f6af5.svg";